<template>
  <div class="d-flex">
    <div class="flex-grow-1 text-right" style="flex-basis: 0">
      {{ data.value.toLocaleString('hun', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
    </div>
  </div>
</template>

<script>
export default {
  name: "CellTemplate",
  props: ['data']
}
</script>

<style scoped>

</style>